import { useEffect, useState } from 'react';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import NavbarAdmin from "../../Components/NavbarAdmin";
import ModalUpdateUser from "../../Components/ModalUpdateUser";
import Dialog from "../../Components/Dialog";
import Modal from 'react-modal';
import CreateOrganisme from '../../Components/CreateOrganisme';
import { escapeHtml, rescueHtml } from '../../Components/Tools';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';
import * as XLSX from 'xlsx';
import { ReactComponent as Trash } from '../../Img/icon-trash.svg';
import CreateBudget from '../../Components/CreateBudget';


const Organismes = (props) =>
{
    const [aff, setAff] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [userFocus, setUserFocus] = useState(false);
    const [liste, setListe] = useState([]);
    const [listeOriginal, setListeOriginal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [boolID, setBoolID] = useState(true);
    const [boolNom, setBoolNom] = useState(false);
    const [boolSiren, setBoolSiren] = useState(false);
    const [boolCodeGeo, setBoolCodeGeo] = useState(false);
    const [boolType, setBoolType] = useState(false);
    const [boolActive, setBoolActive] = useState(false);
    const [filterNom, setFilterNom] = useState('');
    const [filterSiren, setFilterSiren] = useState('');
    const [filterCodeGeo, setFilterCodeGeo] = useState('');
    const [filterType, setFilterType] = useState('');
    const [filterActive, setFilterActive] = useState('');
    const [typesOrganismes, setTypesOrganismes] = useState([]);
    const [modalBudgetsVisible, setModalBudgetsVisible] = useState(false);
    const [budgetsList, setBudgetsList] = useState([]);
    const [selectedOrganismeBudgets, setSelectedOrganismeBudgets] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const heightObject = window.innerHeight/1.9;

    const budgetColumns = budgetsList && budgetsList.length > 0 ? Object.keys(budgetsList[0]).filter(col => !/^[0-9]+$/.test(col)) : [];
    const excludedFctvaCols = ['n', 'n-1', 'n-2'];

    const getFctvaYearLabel = (b) => {
        const labels = [];
        try {
            if (b['n'] === 1 || b['n'] === '1' || b['n'] === true) labels.push('N');
            if (b['n-1'] === 1 || b['n-1'] === '1' || b['n-1'] === true) labels.push('N-1');
            if (b['n-2'] === 1 || b['n-2'] === '1' || b['n-2'] === true) labels.push('N-2');
        } catch (e) {
            // ignore
        }
        return labels.length ? labels.join(', ') : '';
    };

    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [pendingDeleteBudgetId, setPendingDeleteBudgetId] = useState(null);

    const [dialogOrganismeVisible, setDialogOrganismeVisible] = useState(false);
    const [dialogOrganismeMessage, setDialogOrganismeMessage] = useState('');
    const [pendingDeleteOrganismeId, setPendingDeleteOrganismeId] = useState(null);
    const [createOrganismeVisible, setCreateOrganismeVisible] = useState(false);
    const [createBudgetVisible, setCreateBudgetVisible] = useState(false);

    const openDeleteDialog = (id_budget) => {
        if (!id_budget) return;
        setPendingDeleteBudgetId(id_budget);
        setDialogMessage('Supprimer ce budget et toutes ses dépendances ?');
        setDialogModalVisible(true);
    };

    const openDeleteOrganismeDialog = (id) => {
        if (!id) return;
        setPendingDeleteOrganismeId(id);
        setDialogOrganismeMessage("Supprimer cet organisme et tous ses budgets ?");
        setDialogOrganismeVisible(true);
    };

    const callbackDialogDelete = async (ret) => {
        // ret === true means confirmed
        setDialogModalVisible(false);
        if (ret && pendingDeleteBudgetId) {
            await performDeleteBudget(pendingDeleteBudgetId);
        }
        setPendingDeleteBudgetId(null);
    };

    const callbackDialogDeleteOrganisme = async (ret) => {
        setDialogOrganismeVisible(false);
        if (ret && pendingDeleteOrganismeId) {
            await performDeleteOrganisme(pendingDeleteOrganismeId);
        }
        setPendingDeleteOrganismeId(null);
    };

    const performDeleteBudget = async (id_budget) => {
        try {
            const params = { deleteBudget: true, id_budget };
            const res = await axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify(params));
            if (res.data && res.data.status === 1) {
                NotificationManager.success(res.data.status_message, '', 1000);
                // refresh budgets list for current organisme if open
                if (selectedOrganismeBudgets && selectedOrganismeBudgets.id) {
                    try {
                        const r = await axios.get(`https://app-slfinance.fr/api/budgets.php?id_organisme=${selectedOrganismeBudgets.id}&list=1`);
                        setBudgetsList(r.data || []);
                    } catch (e) { console.warn(e); }
                    // update count locally
                    setListe(liste.map(org => org.id === selectedOrganismeBudgets.id ? {...org, budgets_count: Math.max(0, (org.budgets_count||0) - 1)} : org));
                }
            }
            else {
                NotificationManager.warning((res.data && res.data.status_message) ? res.data.status_message : 'Erreur suppression');
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de la suppression du budget');
        }
    };

    const performDeleteOrganisme = async (id_organisme) => {
        try {
            const params = { deleteOrganisme: true, id_organisme };
            const res = await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params));
            if (res.data && res.data.status === 1) {
                // Also remove budgets for this organisme
                try {
                    await axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify({ deleteBudgets: true, id_organisme }));
                } catch (e) { console.warn(e); }

                NotificationManager.success(res.data.status_message || 'Organisme supprimé', '', 1000);
                // remove from local lists
                setListe(prev => prev.filter(o => o.id !== id_organisme));
                setListeOriginal(prev => prev.filter(o => o.id !== id_organisme));
            }
            else {
                NotificationManager.warning((res.data && res.data.status_message) ? res.data.status_message : 'Erreur suppression organisme');
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de la suppression de l\'organisme');
        }
    };

    const getColFlex = (col) => {
        const lname = col.toLowerCase();
        if (lname === 'id' || lname === 'id_budget') return isMobile ? '0 0 12%' : 0.08;
        if (lname.includes('nom') || lname.includes('name')) return isMobile ? 1 : 0.4;
        if (lname.includes('siret')) return isMobile ? '0 0 20%' : 0.2;
        if (lname.includes('annexe') || lname.includes('budget_annexe')) return isMobile ? '0 0 18%' : 0.15;
        return isMobile ? '0 0 20%' : 0.15;
    };

    async function fetchBudgetsCounts(organismes) {
        try {
            const promises = organismes.map(org =>
                axios.get(`https://app-slfinance.fr/api/budgets.php?id_organisme=${org.id}&list=1`)
                    .then(res => Array.isArray(res.data) ? res.data.length : 0)
                    .catch(() => 0)
            );
            const counts = await Promise.all(promises);
            const updated = organismes.map((org, idx) => ({...org, budgets_count: counts[idx] || 0}));
            setListe(updated);
            setListeOriginal(updated.map(org => ({...org})));
        } catch (err) {
            console.warn('Erreur fetchBudgetsCounts', err);
        }
    }

    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#28A745';

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        }
        else {
            getOrganismes();
            getOrganismesType();
        }
    }, [props.user])


    async function getOrganismes()
    {
        setIsLoading(true);
        axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({'getOrganismes': true}))
        .then((res) => {
            // Convertir active en nombre pour éviter les problèmes de comparaison
            const organizmesWithActiveAsNumber = res.data.map(org => ({
                ...org,
                active: parseInt(org.active)
            }));
            setListe(organizmesWithActiveAsNumber);
            setListeOriginal(organizmesWithActiveAsNumber.map(org => ({...org})));
            // Récupérer le nombre de budgets pour chaque organisme (non bloquant)
            fetchBudgetsCounts(organizmesWithActiveAsNumber);
            setIsLoading(false);
        })
        .catch((err) => {
            console.warn(err)
            setIsLoading(false);
        })
    }

    async function getOrganismesType()
    {
        axios.post("https://app-slfinance.fr/api/organismes_type.php", qs.stringify({'getOrganismesType': true}))
        .then((res) => {
            setTypesOrganismes(res.data);
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    const handleOrganismeChange = (id, field, value) => {
        // Trouver l'organisme actuel
        const currentOrganisme = liste.find(org => org.id === id);
        
        // Comparer la nouvelle valeur avec l'ancienne
        if (currentOrganisme[field] === value) {
            // Les valeurs sont identiques, ne rien faire
            return;
        }
        
        // Les valeurs sont différentes, créer l'organisme mis à jour
        const updatedOrganisme = {...currentOrganisme, [field]: value};
        
        // Mettre à jour la liste
        setListe(liste.map(org => 
            org.id === id ? updatedOrganisme : org
        ));
        
        // Sauvegarder si active ou id_organisme_type
        if (field === 'active' || field === 'id_organisme_type') {
            saveOrganisme(updatedOrganisme);
        }
    };

    const saveOrganisme = async (organisme) => {
        // Vérifier s'il y a eu un changement
        const original = listeOriginal.find(org => org.id === organisme.id);
        
        if (!original) return;
        
        const hasChanged = 
            original.nom !== organisme.nom ||
            original.siren !== organisme.siren ||
            original.code_geo !== organisme.code_geo ||
            original.id_organisme_type !== organisme.id_organisme_type ||
            original.active !== organisme.active;
        
        // Ne pas sauvegarder s'il n'y a pas de changement
        if (!hasChanged) {
            return;
        }
        
        try {
            const response = await axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({
                'updateOrganisme': true,
                'id': organisme.id,
                'nom': escapeHtml(organisme.nom),
                'siren': organisme.siren,
                'code_geo': organisme.code_geo,
                'id_organisme_type': organisme.id_organisme_type,
                'active': organisme.active
            }));
            
            if(response.data.status === 1) {
                NotificationManager.success(response.data.status_message);
                // Mettre à jour la version originale aussi
                setListeOriginal(listeOriginal.map(org => 
                    org.id === organisme.id ? {...organisme} : org
                ));
            } else {
                NotificationManager.error(response.data.status_message);
                getOrganismes();
            }
        } catch(err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de la sauvegarde');
            getOrganismes();
        }
    };

    const saveBudget = async (budget) => {
        if (!budget || (!budget.id && !budget.ID)) return;
        const id_budget = budget.id || budget.ID || budget.Id;
        const payload = {
            updateBudget: true,
            id_budget: id_budget
        };
        if (budget.id_organisme !== undefined) payload['id_organisme'] = budget.id_organisme;
        if (budget.nom !== undefined) payload['nom'] = budget.nom;
        if (budget.siret !== undefined) payload['siret'] = budget.siret;
        if (budget.budget_annexe !== undefined) payload['budget_annexe'] = budget.budget_annexe;

        try {
            const res = await axios.post("https://app-slfinance.fr/api/budgets.php", qs.stringify(payload));
            // refresh budgets list for the selected organisme
            if (selectedOrganismeBudgets) {
                try {
                    const r = await axios.get(`https://app-slfinance.fr/api/budgets.php?id_organisme=${selectedOrganismeBudgets.id}&list=1`);
                    setBudgetsList(r.data || []);
                } catch (e) {
                    console.warn('refresh budgets after save failed', e);
                }
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de la sauvegarde du budget');
        }
    };

    const saveNomen = async (id_budget, value) => {
        try {
            const params = {
                set_config_budget_objet: true,
                id_budget: id_budget,
            };
            // use nested param to send objet[nomen]=value
            const form = qs.stringify({ ...params, 'objet[nomen]': value });
            const res = await axios.post('https://app-slfinance.fr/api/config_budget.php', form);
            if (res.data && res.data.status === 1) {
                NotificationManager.success(res.data.status_message || 'Nomen mis à jour', '', 800);
            } else {
                NotificationManager.warning(res.data.status_message || 'Erreur mise à jour nomen');
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de la sauvegarde du nomen');
        }
    };

    const renderBudgetCell = (b, col, idx) => {
        const val = b[col];
        if (col === 'budget_annexe' || col.toLowerCase() === 'budget_annexe') {
            return (
                <select
                    value={val}
                    onChange={(e) => {
                        const newVal = e.target.value === '1' ? 1 : 0;
                        const updated = [...budgetsList];
                        updated[idx] = {...b, [col]: newVal};
                        setBudgetsList(updated);
                        saveBudget(updated[idx]);
                    }}
                    style={{padding: '8px', borderRadius: 4, border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer'}}
                >
                    <option value={0}>BP</option>
                    <option value={1}>BA</option>
                </select>
            );
        }
        if (col === 'siret') {
            return (
                <input
                    type="text"
                    value={val || ''}
                    onChange={(e) => {
                        const v = e.target.value.replace(/[^0-9;]/g, '');
                        const updated = [...budgetsList];
                        updated[idx] = {...b, [col]: v};
                        setBudgetsList(updated);
                    }}
                    onBlur={() => saveBudget(budgetsList[idx])}
                    style={{width: '100%', padding: '6px 8px', border: 'none', outline: 'none', backgroundColor: 'transparent', textAlign: 'center'}}
                />
            );
        }
        if (col.toLowerCase().includes('nom')) {
            return (
                <input
                    type="text"
                    value={val || ''}
                    onChange={(e) => {
                        const v = e.target.value;
                        const updated = [...budgetsList];
                        updated[idx] = {...b, [col]: v};
                        setBudgetsList(updated);
                    }}
                    onBlur={() => saveBudget(budgetsList[idx])}
                    style={{width: '100%', padding: '6px 8px', border: 'none', outline: 'none', backgroundColor: 'transparent'}}
                />
            );
        }
        if (col === 'id_organisme') {
            return (
                <input
                    type="number"
                    value={val || ''}
                    onChange={(e) => {
                        const v = e.target.value.replace(/[^0-9]/g, '');
                        const updated = [...budgetsList];
                        updated[idx] = {...b, [col]: v};
                        setBudgetsList(updated);
                    }}
                    onBlur={() => saveBudget(budgetsList[idx])}
                    style={{width: '100%', padding: '6px 8px', border: 'none', outline: 'none', backgroundColor: 'transparent', textAlign: 'center'}}
                />
            );
        }

        return (<p style={{margin: 0, fontSize: isMobile ? '11px' : '14px'}}>{val !== null && val !== undefined ? val.toString() : ''}</p>);
    };

    const getListeFiltered = () => {
        return liste.filter(organisme => {
            const nomMatch = organisme.nom.toLowerCase().includes(filterNom.toLowerCase());
            const sirenMatch = filterSiren === '' || organisme.siren.toString().includes(filterSiren);
            const codeGeoMatch = filterCodeGeo === '' || organisme.code_geo.toLowerCase().includes(filterCodeGeo.toLowerCase());
            const typeMatch = filterType === '' || organisme.id_organisme_type.toString() === filterType;
            const activeMatch = filterActive === '' || organisme.active.toString() === filterActive;
            
            return nomMatch && sirenMatch && codeGeoMatch && typeMatch && activeMatch;
        });
    };

    const downloadCSV = () => {
        const filteredData = getListeFiltered();
        const headers = ['Active', 'ID', 'Nom Organisme', 'SIREN', 'Code Géo', 'Type Organisme'];
        
        const getTypeLabel = (typeId) => {
            const type = typesOrganismes.find(t => t.id == typeId);
            return type ? type.nom_categorie : typeId;
        };

        let csvContent = headers.join(',') + '\n';
        
        filteredData.forEach(organisme => {
            const row = [
                organisme.active === 1 ? 'Oui' : 'Non',
                organisme.id,
                `"${organisme.nom}"`,
                organisme.siren,
                organisme.code_geo,
                getTypeLabel(organisme.id_organisme_type)
            ];
            csvContent += row.join(',') + '\n';
        });

        // Construire le nom du fichier avec les filtres
        let filename = 'organismes';
        if (filterNom) filename += '_nom-' + filterNom.replace(/[^a-zA-Z0-9]/g, '');
        if (filterSiren) filename += '_siren-' + filterSiren.replace(/[^a-zA-Z0-9]/g, '');
        if (filterCodeGeo) filename += '_code-' + filterCodeGeo.replace(/[^a-zA-Z0-9]/g, '');
        if (filterType) {
            const typeLabel = typesOrganismes.find(t => t.id == filterType)?.nom_categorie || filterType;
            filename += '_type-' + typeLabel.replace(/[^a-zA-Z0-9]/g, '');
        }
        filename += '_' + new Date().toISOString().split('T')[0] + '.csv';

        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        NotificationManager.success('CSV téléchargé');
    };

    const downloadXLSX = () => {
        const filteredData = getListeFiltered();
        const headers = ['Active', 'ID', 'Nom Organisme', 'SIREN', 'Code Géo', 'Type Organisme'];
        
        const getTypeLabel = (typeId) => {
            const type = typesOrganismes.find(t => t.id == typeId);
            return type ? type.nom_categorie : typeId;
        };
        
        const sheetData = [
            headers,
            ...filteredData.map(organisme => [
                organisme.active === 1 ? 'Oui' : 'Non',
                organisme.id,
                rescueHtml(organisme.nom),
                organisme.siren,
                organisme.code_geo,
                getTypeLabel(organisme.id_organisme_type)
            ])
        ];

        // Construire le nom du fichier avec les filtres
        let filename = 'organismes';
        if (filterNom) filename += '_nom-' + filterNom.replace(/[^a-zA-Z0-9]/g, '');
        if (filterSiren) filename += '_siren-' + filterSiren.replace(/[^a-zA-Z0-9]/g, '');
        if (filterCodeGeo) filename += '_code-' + filterCodeGeo.replace(/[^a-zA-Z0-9]/g, '');
        if (filterType) {
            const typeLabel = typesOrganismes.find(t => t.id == filterType)?.nom_categorie || filterType;
            filename += '_type-' + typeLabel.replace(/[^a-zA-Z0-9]/g, '');
        }
        filename += '_' + new Date().toISOString().split('T')[0] + '.xlsx';

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Organismes');
        
        XLSX.writeFile(workbook, filename);
        NotificationManager.success('XLSX téléchargé');
    };

    function compareIdAsc(a, b)
    {
        return a.id - b.id;
    }

    function compareIdDes(a, b)
    {
        return b.id - a.id;
    }

    function compareNomAsc(a, b)
    {
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
        
        if (nomA < nomB) return -1;
        if (nomA > nomB) return 1;
        return 0;
    }

    function compareNomDes(a, b)
    {
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
        
        if (nomA > nomB) return -1;
        if (nomA < nomB) return 1;
        return 0;
    }

    function compareSirenAsc(a, b)
    {
        return a.siren - b.siren;
    }

    function compareSirenDes(a, b)
    {
        return b.siren - a.siren;
    }

    function compareCodeGeoAsc(a, b)
    {
        const codeA = a.code_geo?a.code_geo.toUpperCase():0;
        const codeB = b.code_geo?b.code_geo.toUpperCase():0;
        
        if (codeA < codeB) return -1;
        if (codeA > codeB) return 1;
        return 0;
    }

    function compareCodeGeoDes(a, b)
    {
        const codeA = a.code_geo?a.code_geo.toUpperCase():0;
        const codeB = b.code_geo?b.code_geo.toUpperCase():0;
        
        if (codeA > codeB) return -1;
        if (codeA < codeB) return 1;
        return 0;
    }

    function compareTypeAsc(a, b)
    {
        return a.id_organisme_type - b.id_organisme_type;
    }

    function compareTypeDes(a, b)
    {
        return b.id_organisme_type - a.id_organisme_type;
    }

    function compareActiveAsc(a, b)
    {
        return a.active - b.active;
    }

    function compareActiveDes(a, b)
    {
        return b.active - a.active;
    }

	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />
            <ModalUpdateUser
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            user={userFocus}
            who={props.user?props.user.id:null}
            />

            <Dialog modalVisible={dialogModalVisible} setModalVisible={setDialogModalVisible} message={dialogMessage} callbackDialog={callbackDialogDelete} />
            <Dialog modalVisible={dialogOrganismeVisible} setModalVisible={setDialogOrganismeVisible} message={dialogOrganismeMessage} callbackDialog={callbackDialogDeleteOrganisme} />

            <div style={{display: 'flex', margin: 25}}>
                <div style={{display: 'flex', flex: 1, alignItems: 'center'}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Organismes</p>
                </div>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 0}}>
                    <button
                        onClick={() => setCreateOrganismeVisible(true)}
                        style={{width:  isMobile ? '150px' : '300px', padding: '8px 16px', backgroundColor: green, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}
                    >
                        + Créer un nouvel organisme
                    </button>
                </div>
                <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
                    <p>Télécharger au format :</p>
                    <button 
                        onClick={downloadCSV}
                        style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ?'11px':'16px'}}
                    >
                        📥 CSV
                    </button>
                    <button 
                        onClick={downloadXLSX}
                        style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ?'11px':'16px'}}
                    >
                        📥 XLSX
                    </button>
                </div>
            </div>

            <Modal
                isOpen={createOrganismeVisible}
                onRequestClose={() => setCreateOrganismeVisible(false)}
                ariaHideApp={false}
                style={{
                    overlay: { zIndex: 2500, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
                    content: {
                        position: 'relative',
                        inset: 'auto',
                        transform: 'translate(0, 0)',
                        maxHeight: '90%',
                        width: isMobile ? '95%' : '700px',
                        borderRadius: 8,
                        padding: 0,
                        // center via flex on overlay, ensure no deffault offset
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto'
                    }
                }}
            >
                <div style={{padding: 16, backgroundColor: 'white'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0 12px 0'}}>
                        <div style={{flex: 1}}></div>
                        <button onClick={() => setCreateOrganismeVisible(false)} style={{padding: 6, borderRadius: 4, border: 'none', backgroundColor: '#eee', cursor: 'pointer'}}>Fermer</button>
                    </div>
                    <CreateOrganisme organismes_type={typesOrganismes} />
                </div>
            </Modal>

            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50, padding: 20, backgroundColor: '#f9f9f9', marginBottom: 20}}>
                <h3 style={{marginTop: 0, marginBottom: 15}}>Filtres</h3>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 15}}>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '200px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Nom Organisme</label>
                        <input 
                            type="text" 
                            placeholder="Filtrer par nom..." 
                            value={filterNom}
                            onChange={(e) => setFilterNom(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        />
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>SIREN</label>
                        <input 
                            type="text" 
                            placeholder="Filtrer par SIREN..." 
                            value={filterSiren}
                            onChange={(e) => setFilterSiren(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        />
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Code Géo</label>
                        <input 
                            type="text" 
                            placeholder="Filtrer par code géo..." 
                            value={filterCodeGeo}
                            onChange={(e) => setFilterCodeGeo(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        />
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Type Organisme</label>
                        <select 
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        >
                            <option value="">Tous</option>
                            {typesOrganismes.map((type) => (
                                <option key={type.id} value={type.id}>{type.nom_categorie}</option>
                            ))}
                        </select>
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Actif</label>
                        <select 
                            value={filterActive}
                            onChange={(e) => setFilterActive(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        >
                            <option value="">Tous</option>
                            <option value="1">Actif</option>
                            <option value="0">Inactif</option>
                        </select>
                    </div>
                </div>
            </div>

            <div style={{margin: isMobile ? 10 : 50, padding: 15, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${blue}`, marginBottom: 20}}>
                <p style={{margin: 0, fontWeight: 'bold', color: '#333', fontSize: isMobile ? '12px' : '14px'}}>
                    {getListeFiltered().length} résultat{getListeFiltered().length > 1 ? 's' : ''} trouvé{getListeFiltered().length > 1 ? 's' : ''}
                </p>
            </div>

            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50}}>
                {isLoading ? (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px'}}>
                        <div style={{textAlign: 'center'}}>
                            <div style={{
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid ' + purple,
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 20px'
                            }}></div>
                            <p style={{color: purple, fontWeight: 'bold'}}>Chargement des organismes...</p>
                        </div>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                ) : (
                    <>
                <div style={{overflowX: 'auto'}}>
                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white', flexWrap: isMobile ? 'wrap' : 'nowrap', borderBottom: '3px solid ' + blue}}>
                        <div style={{flex: isMobile ? '0 0 40px' : 0.05, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', minHeight: isMobile ? '40px' : '45px', minWidth: '40px', backgroundColor: blue}}>
                            <Trash style={{width: isMobile ? 14 : 18, height: isMobile ? 14 : 18}} />
                        </div>
                        
                        <button
                        onClick={async () => {
                            if (boolActive) {
                                await liste.sort(compareActiveDes);
                            }
                            else {
                                await liste.sort(compareActiveAsc);
                            }
                            await setBoolActive(!boolActive);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 12%' : 0.08, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '35px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>Actif</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolID) {
                                await liste.sort(compareIdDes);
                            }
                            else {
                                await liste.sort(compareIdAsc);
                            }
                            await setBoolID(!boolID);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 12%' : 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '40px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>ID</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolNom) {
                                await liste.sort(compareNomDes);
                            }
                            else {
                                await liste.sort(compareNomAsc);
                            }
                            await setBoolNom(!boolNom);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? 1 : 0.4, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '150px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>{isMobile ? 'Nom' : 'Nom Organisme'}</p>
                        </button>
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolSiren) {
                                await liste.sort(compareSirenDes);
                            }
                            else {
                                await liste.sort(compareSirenAsc);
                            }
                            await setBoolSiren(!boolSiren);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: '12px 8px', fontSize: '14px', fontWeight: 'bold', minHeight: '45px', minWidth: '100px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>SIREN</p>
                        </button>
                        )}
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolCodeGeo) {
                                await liste.sort(compareCodeGeoDes);
                            }
                            else {
                                await liste.sort(compareCodeGeoAsc);
                            }
                            await setBoolCodeGeo(!boolCodeGeo);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: '12px 8px', fontSize: '14px', fontWeight: 'bold', minHeight: '45px', minWidth: '100px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>Code Géo</p>
                        </button>
                        )}
                        
                        <button
                        onClick={async () => {
                            if (boolType) {
                                await liste.sort(compareTypeDes);
                            }
                            else {
                                await liste.sort(compareTypeAsc);
                            }
                            await setBoolType(!boolType);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 20%' : 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '80px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>{isMobile ? 'Type' : 'Type Org'}</p>
                        </button>

                        <button
                        onClick={async () => {
                            // toggle header sort for budgets (no sorting, just keeps layout consistent)
                            setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 20%' : 0.15, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '80px', backgroundColor: blue, cursor: 'default', transition: 'all 0.2s'}}
                        >
                            <p style={{margin: 0}}>{isMobile ? 'Budg.' : 'Budgets'}</p>
                        </button>
                    
                    </div>
                </div>

                <div style={{overflowY: 'auto', maxHeight: heightObject, backgroundColor: '#fafafa'}}>
                    {getListeFiltered().map((organisme, i) =>
                    <div key={i} style={{display: 'flex', flexWrap: isMobile ? 'wrap' : 'nowrap', width: '100%', borderBottom: '1px solid #e0e0e0', transition: 'all 0.2s', backgroundColor: i % 2 === 0 ? '#ffffff' : '#f5f5f5'}}>
                        <div style={{flex: isMobile ? '0 0 40px' : 0.05, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '40px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd'}}>
                            <button onClick={() => openDeleteOrganismeDialog(organisme.id)} style={{background: 'transparent', border: 'none', cursor: 'pointer', padding: 6}} title="Supprimer l'organisme">
                                <Trash style={{width: isMobile ? 16 : 20, height: isMobile ? 16 : 20}} />
                            </button>
                        </div>
                        <div style={{flex: isMobile ? '0 0 12%' : 0.08, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '35px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd'}}>
                            <input 
                                type="checkbox"
                                checked={organisme.active === 1}
                                onChange={(e) => handleOrganismeChange(organisme.id, 'active', e.target.checked ? 1 : 0)}
                                style={{cursor: 'pointer', width: '18px', height: '18px'}}
                            />
                        </div>
                        <div style={{flex: isMobile ? '0 0 12%' : 0.1, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '40px', backgroundColor: 'transparent', fontWeight: 'bold', color: '#333', borderLeft: '1px solid #ddd'}}>
                            <p style={{margin: 0, fontSize: isMobile ? '11px' : '14px'}}>{organisme.id}</p>
                        </div>
                        <input 
                            type="text"
                            value={rescueHtml(organisme.nom)}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'nom', e.target.value)}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: isMobile ? 1 : 0.4, padding: isMobile ? '10px 6px' : '10px 8px', minHeight: isMobile ? '45px' : '50px', minWidth: '150px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: isMobile ? '10px' : '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        />
                        {!isMobile && (
                        <input 
                            type="text"
                            value={organisme.siren}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleOrganismeChange(organisme.id, 'siren', numericValue);
                            }}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: 0.2, padding: '10px 8px', textAlign: 'center', minHeight: '50px', minWidth: '100px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        />
                        )}
                        {!isMobile && (
                        <input 
                            type="text"
                            value={organisme.code_geo}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'code_geo', e.target.value)}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: 0.2, padding: '10px 8px', textAlign: 'center', minHeight: '50px', minWidth: '100px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        />
                        )}
                        {!isMobile && (
                        <select 
                            value={organisme.id_organisme_type}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'id_organisme_type', e.target.value)}
                            style={{flex: 0.2, padding: '10px 8px', textAlign: 'center', minHeight: '50px', minWidth: '100px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', cursor: 'pointer', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            {typesOrganismes.map((type) => (
                                <option key={type.id} value={type.id}>{type.nom_categorie}</option>
                            ))}
                        </select>
                        )}
                        {isMobile && (
                        <select 
                            value={organisme.id_organisme_type}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'id_organisme_type', e.target.value)}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: '0 0 20%', padding: '10px 4px', textAlign: 'center', minHeight: '45px', minWidth: '80px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '11px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', cursor: 'pointer', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            {typesOrganismes.map((type) => (
                                <option key={type.id} value={type.id}>{type.nom_categorie}</option>
                            ))}
                        </select>
                        )}
                        <div style={{flex: isMobile ? '0 0 20%' : 0.15, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '80px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd'}}>
                            <button
                                onClick={async () => {
                                    // fetch budgets for this organisme and show modal
                                    try {
                                        const res = await axios.get(`https://app-slfinance.fr/api/budgets.php?id_organisme=${organisme.id}&list=1`);
                                        let budgets = res.data || [];
                                        // fetch nomen from config_budget for each budget
                                        const withNomenPromises = budgets.map(async (b) => {
                                            try {
                                                const cfg = await axios.get(`https://app-slfinance.fr/api/config_budget.php?id_budget=${b.id || b.ID || b.Id}`);
                                                // cfg.data is an array of rows: [[id,id_budget,parametre,valeur],...]
                                                let nomen = '';
                                                if (Array.isArray(cfg.data)) {
                                                    for (const row of cfg.data) {
                                                        // row could be array or object
                                                        if (Array.isArray(row)) {
                                                            const param = row[2];
                                                            const val = row[3];
                                                            if (param === 'nomen') { nomen = val || ''; break; }
                                                        }
                                                        else if (row.parametre) {
                                                            if (row.parametre === 'nomen') { nomen = row.valeur || ''; break; }
                                                        }
                                                    }
                                                }
                                                return {...b, nomen: nomen};
                                            } catch (e) {
                                                return {...b, nomen: ''};
                                            }
                                        });
                                        budgets = await Promise.all(withNomenPromises);
                                        setBudgetsList(budgets);
                                        setSelectedOrganismeBudgets(organisme);
                                        setModalBudgetsVisible(true);
                                    } catch (err) {
                                        console.warn(err);
                                        NotificationManager.error('Erreur lors de la récupération des budgets');
                                    }
                                }}
                                style={{width: '100%', height: '100%', padding: '6px 10px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ? '11px' : '13px'}}
                            >
                                {organisme.budgets_count !== undefined ? organisme.budgets_count : 'aucun'} budget(s)
                            </button>
                        </div>
                    </div>
                    )}

                </div>

                    </>
                )}

                {modalBudgetsVisible && (
                    <div onClick={(e) => { if (!createBudgetVisible) { setModalBudgetsVisible(false); setBudgetsList([]); setSelectedOrganismeBudgets(null); } }} style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000}}>
                        <div onClick={(e) => e.stopPropagation()} style={{width: isMobile ? '95%' : '80%', maxHeight: '80%', overflowY: 'auto', backgroundColor: '#fff', borderRadius: 8, padding: 20}}>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12}}>
                                <h3 style={{margin: 0}}>Budgets — {selectedOrganismeBudgets ? rescueHtml(selectedOrganismeBudgets.nom) : ''}</h3>
                                <div style={{display: 'flex', gap: 8}}>
                                    <button onClick={() => setCreateBudgetVisible(true)} style={{padding: '6px 10px', borderRadius: 4, border: 'none', backgroundColor: green, color: 'white', cursor: 'pointer'}}>Créer un budget</button>
                                    <button onClick={() => { setModalBudgetsVisible(false); setBudgetsList([]); setSelectedOrganismeBudgets(null); }} style={{padding: '6px 10px', borderRadius: 4, border: 'none', backgroundColor: '#eee', cursor: 'pointer'}}>Fermer</button>
                                </div>
                            </div>

                            {budgetsList.length === 0 ? (
                                <p>Aucun budget trouvé pour cet organisme.</p>
                            ) : (
                                <div style={{overflowX: 'auto'}}>
                                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white', flexWrap: isMobile ? 'wrap' : 'nowrap', borderBottom: '3px solid ' + blue}}>
                                        <div style={{flex: isMobile ? '0 0 40px' : 0.05, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '40px', backgroundColor: blue}}>
                                            <p style={{margin: 0}}>Suppr</p>
                                        </div>
                                        {budgetColumns.filter(col => !excludedFctvaCols.includes(col)).map((col) => (
                                            <div key={col} style={{flex: getColFlex(col), alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '80px', backgroundColor: blue}}>
                                                <p style={{margin: 0}}>{col}</p>
                                            </div>
                                        ))}
                                        <div style={{flex: isMobile ? '0 0 20%' : 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '120px', backgroundColor: blue}}>
                                            <p style={{margin: 0}}>Année de versement FCTVA</p>
                                        </div>
                                    </div>

                                    <div style={{maxHeight: isMobile ? '60vh' : '50vh', overflowY: 'auto', backgroundColor: '#fafafa'}}>
                                        {budgetsList.map((b, idx) => (
                                            <div key={idx} style={{display: 'flex', flexWrap: isMobile ? 'wrap' : 'nowrap', width: '100%', borderBottom: '1px solid #e0e0e0', transition: 'all 0.2s', backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f5f5f5'}}>
                                                <div style={{flex: isMobile ? '0 0 40px' : 0.05, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '40px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd'}}>
                                                    <button onClick={() => openDeleteDialog(b.id || b.ID || b.Id)} style={{background: 'transparent', border: 'none', cursor: 'pointer', padding: 6}} title="Supprimer le budget">
                                                        <Trash style={{width: isMobile ? 16 : 20, height: isMobile ? 16 : 20}} />
                                                    </button>
                                                </div>
                                                {budgetColumns.filter(col => !excludedFctvaCols.includes(col)).map((col) => (
                                                    <div key={col} style={{flex: getColFlex(col), display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '80px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd', boxSizing: 'border-box', color: '#333'}}>
                                                        {col === 'nomen' ? (
                                                            <input
                                                                type="text"
                                                                value={b.nomen || ''}
                                                                onChange={(e) => {
                                                                    const v = e.target.value;
                                                                    const updated = [...budgetsList];
                                                                    updated[idx] = {...b, nomen: v};
                                                                    setBudgetsList(updated);
                                                                }}
                                                                onBlur={() => saveNomen(b.id || b.ID || b.Id, budgetsList[idx].nomen || '')}
                                                                style={{width: '100%', padding: '6px 8px', border: 'none', outline: 'none', backgroundColor: 'transparent'}}
                                                            />
                                                        ) : (
                                                            renderBudgetCell(b, col, idx)
                                                        )}
                                                    </div>
                                                ))}
                                                <div style={{flex: isMobile ? '0 0 20%' : 0.2, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '120px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd'}}>
                                                    <p style={{margin: 0, fontSize: isMobile ? '11px' : '14px'}}>{getFctvaYearLabel(b)}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                            <Modal isOpen={createBudgetVisible} onRequestClose={() => setCreateBudgetVisible(false)} ariaHideApp={false} style={{overlay: {zIndex: 2600, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'}, content: {position: 'relative', inset: 'auto', transform: 'translate(0, 0)', maxHeight: '90%', width: isMobile ? '95%' : '700px', borderRadius: 8, padding: 0}}}>
                                <div style={{padding: 16, backgroundColor: 'white'}}>
                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0 12px 0'}}>
                                        <div style={{flex: 1}}></div>
                                        <button onClick={() => setCreateBudgetVisible(false)} style={{padding: 6, borderRadius: 4, border: 'none', backgroundColor: '#eee', cursor: 'pointer'}}>Fermer</button>
                                    </div>
                                    <CreateBudget organismes={selectedOrganismeBudgets ? [{id: selectedOrganismeBudgets.id, nom: rescueHtml(selectedOrganismeBudgets.nom)}] : []} defaultOrganismeId={selectedOrganismeBudgets ? selectedOrganismeBudgets.id : null} />
                                </div>
                            </Modal>
                    </div>
                )}
            </div>

        </Access>
	);
}


export default Organismes;
